module.exports = __webpack_public_path__ + "assets/bf72eca426c90abc8ba8df0cdc7ef157.svg";